import { motion } from 'framer-motion';

const WhyItWorksCard = ({ title, illustration, illustrationLeft, illustrationRight, illustrationWidth, cardBackground, index = 0 }) => (
  <div
    className="relative flex flex-col items-start gap-5 w-full max-w-[384px] h-[274px] border border-[#CBD5E1] rounded-[20px] p-3 overflow-hidden"
    style={{ background: cardBackground || '#FFFFFF' }}
  >
    <span className="relative z-10 font-gilroy-bold text-[16px] leading-[22px] sm:text-[20px] sm:leading-7 tracking-[0.02em] text-[#020617] max-w-[360px]">
      {title}
    </span>
    {illustration && (
      <motion.img
        src={illustration}
        alt=""
        className="absolute bottom-0 max-w-none pointer-events-none select-none"
        style={{
          ...(illustrationRight != null
            ? { right: illustrationRight }
            : illustrationLeft != null
              ? { left: illustrationLeft }
              : { left: '50%', x: '-50%' }),
          ...(illustrationWidth != null ? { width: illustrationWidth } : {}),
        }}
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5, delay: 0.15 + (index % 3) * 0.15, ease: 'easeOut' }}
      />
    )}
  </div>
);

export default WhyItWorksCard;
